"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/** StatsMixin class */
var StatsMixin = /** @class */ (function () {
    function StatsMixin() {
    }
    /**
     * getStats
     * @param start
     * @param end
     * @param callback
     */
    StatsMixin.prototype.getStats = function (start, end, callback) {
        var _this = this;
        var params = {
            start: Math.floor(start.getTime() / 1000),
            end: Math.floor(end.getTime() / 1000),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Stats.parse));
        };
        this.http.get('/stats', params, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getSalesReport
     * @param callback
     */
    StatsMixin.prototype.getSalesReport = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.ReportResult.parse));
        };
        this.http.get('/reports/active-agencies', null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getSalesReportId
     * @param reportId
     */
    StatsMixin.prototype.getSalesReportDataUrl = function (reportId) {
        return this.apiRoot + "/reports/" + reportId + "/data";
    };
    return StatsMixin;
}());
exports.default = StatsMixin;
//# sourceMappingURL=StatsMixin.js.map